import { Mars, Moon, Jupiter, Venus, Neptune, JupiterBg } from '../assets'

export const footerImg = () => {
  return (
    [
      {
        id:"1",
        subTitle: "",
        img: Neptune,
        date: ""
        
      },
      {
        id: "2",
        subTitle: "",
        img: Mars,
        date: ""
      },
      {
        id: "3",
        subTitle: "",
        img: Jupiter,
        date: ""
      },
      {
        id: "4",
        subTitle: "",
        img: Venus,
        date: ""
      },
      {
        id: "5",
        subTitle: "",
        img:Moon ,
        date: ""
      }
    ]
  )
}
